import React from 'react';
import classNames from 'classnames/bind';
import { Container } from '@carnica/smart-kit';
import { IconGiftFilled, IconGiftOutline, IconSettings, IconSettingsOutline, IconShieldFilled, IconShieldOutline } from '@carnica/graphics';
import { Text } from '@carnica/ui-kit';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../../../utils";
import { defineIconFromUrl } from "./utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _AdditionalInfo = function _AdditionalInfo(_ref) {
  var title = _ref.title,
    description = _ref.description,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? 'brand-primary' : _ref$iconColor,
    _ref$iconWrapper = _ref.iconWrapper,
    iconWrapper = _ref$iconWrapper === void 0 ? true : _ref$iconWrapper,
    invert = _ref.invert,
    icon = _ref.icon,
    iconType = _ref.iconType;
  var getIconComponent = function getIconComponent() {
    var calculatedType = iconType !== null && iconType !== void 0 ? iconType : icon === 'settings' ? 'filled' : 'outline';
    if (iconType === 'hidden') return null;
    switch (icon) {
      case 'gift':
        return calculatedType === 'filled' ? IconGiftFilled : IconGiftOutline;
      case 'settings':
        return calculatedType === 'filled' ? IconSettings : IconSettingsOutline;
      case 'shield':
        return calculatedType === 'filled' ? IconShieldFilled : IconShieldOutline;
      default:
        return defineIconFromUrl(icon);
    }
  };
  var IconComponent = React.useMemo(getIconComponent, [icon, iconType]);
  return /*#__PURE__*/React.createElement(Container.Flex, {
    align: "center",
    gap: 8
  }, IconComponent && /*#__PURE__*/React.createElement("div", {
    className: cx(iconWrapper && 'icon-wrapper', iconWrapper && (invert ? 'background-invert' : 'background')),
    "data-t-id": "components-AdditionalInfo"
  }, /*#__PURE__*/React.createElement(IconComponent, {
    color: iconColor,
    size: iconWrapper ? 16 : 24
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    color: invert ? 'primary-invert' : 'primary',
    variant: invert ? 'caption-medium' : 'body-small'
  }, title), /*#__PURE__*/React.createElement(Text, {
    color: invert ? 'secondary-invert' : 'secondary',
    variant: invert ? 'caption-medium' : 'body-small'
  }, description)));
};
export var AdditionalInfo = enhancedConnect({
  description: PropTypes.string,
  title: PropTypes.string,
  iconWrapper: PropTypes.bool,
  invert: PropTypes.bool,
  iconColor: PropTypes.string,
  icon: PropTypes.string,
  iconType: PropTypes.oneOf(['outline', 'filled', 'hidden'])
})(_AdditionalInfo);